import { NgComponentOutlet } from "@angular/common";
import { Component, Input, Type } from "@angular/core";
import { AP_CHART_COMPONENTS } from "@tylertech/accounts-payable-module";
import { CommonChartComponent } from "@tylertech/charting-module";
import { GL_CHART_COMPONENTS } from "@tylertech/general-ledger-module";
import { IN_CHART_COMPONENTS } from "@tylertech/inventory-module";
import { PR_CHART_COMPONENTS } from "@tylertech/personnel-module";
import { PA_CHART_COMPONENTS } from "@tylertech/project-accounting-module";
import { PO_CHART_COMPONENTS } from "@tylertech/purchasing-module";
import { SA_CHART_COMPONENTS } from "@tylertech/student-activities-module";
import { IChartCriteria } from "@tylertech/tyler-api-types";
import { UB_CHART_COMPONENTS } from "@tylertech/utility-billing-module";
import { InBalanceComponent } from "../inBalance";

const CHART_COMPONENTS: Record<string, Type<unknown>> = {
    "ErpPro.InBalanceCard": InBalanceComponent,
    ...AP_CHART_COMPONENTS,
    ...IN_CHART_COMPONENTS,
    ...GL_CHART_COMPONENTS,
    ...PR_CHART_COMPONENTS,
    ...PA_CHART_COMPONENTS,
    ...PO_CHART_COMPONENTS,
    ...SA_CHART_COMPONENTS,
    ...UB_CHART_COMPONENTS
};

@Component({
    selector: "dashboard-chart",
    imports: [
        CommonChartComponent,
        NgComponentOutlet,
    ],
    templateUrl: "./dashboardChart.tmpl.html",
})
export class DashboardChartComponent
{
    private _chartCriteria: IChartCriteria;

    chartComponent: Type<unknown> | null;
    chartInputs: Record<string, unknown>;

    @Input()
    get chartCriteria(): IChartCriteria { return this._chartCriteria; }

    set chartCriteria(value: IChartCriteria)
    {
        this._chartCriteria = value;
        if (this._chartCriteria?.ChartId)
            this.chartComponent = CHART_COMPONENTS[this._chartCriteria.ChartId] ?? null;
        this.chartInputs = { chartCriteria: value };
    }
}
